/* global require */
import Vue from "vue";

import { EventBus } from "./event-bus.js";

import { trans } from "common/translate";

export default Vue.component("facet", {
  props: [ "facet", "mode", "fieldname", "tabindex", "isManuscript" ],

  data() {
    return {};
  },

  methods: {
    emitAddFilter(name, group) {
      EventBus.$emit("query-with-filter", [ name, group ]);
    }
  },

  computed: {
    translatedFieldname() {
      return trans(this.fieldname);
    }
  },

  template: require("./templates/facet.html"),
});




// WEBPACK FOOTER //
// ./src/frontend/pages/explore-the-archive/archive/facet.js